// useIndexedDB.ts
import { useCallback, useEffect, useState } from 'react';

export const useIndexedDB = <T = any>(key: string) => {
  const [value, setValue] = useState<T | null>(null);
  const [initd, setInitd] = useState(false);

  useEffect(() => {
    const fetchValue = async () => {
      const item = await import('../storage/indexedDB/keyValues').then(({ db }) =>
        db.keyValues.get({ key })
      );
      if (item) {
        setValue(item.value);
      }
    };

    fetchValue().finally(() => {
      setInitd(true);
    });
  }, [key]);

  const setItem = useCallback(
    async (newValue: T) => {
      await import('../storage/indexedDB/keyValues').then(({ db }) =>
        db.keyValues.put({ key, value: newValue })
      );
      setValue(newValue);
    },
    [key]
  );

  const removeItem = useCallback(async () => {
    await import('../storage/indexedDB/keyValues').then(({ db }) => db.keyValues.delete(key));
    setValue(null);
  }, [key]);

  return { value, setItem, removeItem, initd };
};
